export default __webpack_public_path__ + "static/media/speech-babel-blue.86f90d13.svg";